export default {
  401: '登录信息已失效',
  403: '当前操作没有权限',
  404: '访问资源不存在',
  default: '系统未知错误，请联系客服处理'
}



// WEBPACK FOOTER //
// ./src/utils/errorCode.js